import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { ChevronRight, Circle } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { sidebarActive } from '@Lib/slices/uiSlice';

function MobileMenuItemHasChild({ item, handleClickItem }) {
  const [isOpen, setIsOpen] = useState(false);
  const routeMatch = useRouteMatch();
  const dispatch = useDispatch();
  const accessPermisions = useSelector((state) => state.user.accessPermisions);
  const userInfo = useSelector((state) => state.user.info);

  useEffect(() => {
    const childMenu = item.child.find((childRoute) => childRoute.path === routeMatch.path);
    if (childMenu) {
      setIsOpen(true);
      dispatch(sidebarActive(item.id));
    }
  }, []);

  const validAccess = (menu) => {
    const accessName = menu.accessName;
    if (!accessName) {
      return true;
    }

    const rolesByProject = userInfo?.roles_by_project || {};
    const allRoles = Object.values(rolesByProject).flatMap((roles) => {
      return Array.isArray(roles) ? roles : [];
    });
    const isPrivileged = Boolean(
      userInfo?.is_super_admin ||
        allRoles.some((role) => String(role).toLowerCase().includes('admin')),
    );

    if (isPrivileged) {
      return true;
    }

    if (accessPermisions && accessPermisions[`${menu.accessName}`]) {
      return true;
    }
    return false;
  };

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };

  return (
    <li className={`nav-item has-sub ${isOpen ? 'open' : ''}`}>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" className="mobile-submenu-toggle d-flex align-items-center" onClick={toggle}>
        {item.icon ? (
          <span className="mobile-menu-icon-slot d-flex align-items-center justify-content-center">
            {React.isValidElement(item.icon) || typeof item.icon === 'function' ? (
              item.icon
            ) : (
              <span dangerouslySetInnerHTML={{ __html: item.icon }} />
            )}
          </span>
        ) : (
          <Circle size={12} />
        )}
        <span className="menu-title mobile-menu-title text-truncate mr-auto">{item.name}</span>
        <ChevronRight size={16} className="chevron-icon" />
      </a>
      {isOpen && (
        <ul className="menu-content mobile-submenu-content">
          {item.child.map(
            (menu) =>
              !menu.hidden &&
              menu.name &&
              validAccess(menu) && (
                <li key={menu.id} className={menu.isActive ? 'active' : ''}>
                  <a
                    className="d-flex align-items-center"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleClickItem(menu);
                    }}
                    href={menu.path}
                  >
                    <Circle size={6} className="mr-1" />
                    <span className="menu-item text-truncate">{menu.name}</span>
                  </a>
                </li>
              ),
          )}
        </ul>
      )}
    </li>
  );
}

MobileMenuItemHasChild.propTypes = {
  item: PropTypes.object,
  handleClickItem: PropTypes.func,
};

export default MobileMenuItemHasChild;
